/* Links.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["size", "type", "children", "href", "onClick", "dataTestId"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _31 = "._1e0c116y{display:inline-flex}";
const _30 = "._o5721q9c{white-space:nowrap}";
const _29 = "._t4pt1hna>span{overflow-wrap:break-word}";
const _28 = "._y3gn1e5h{text-align:left}";
const _27 = "._1e0c1o8l{display:inline-block}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _26 = "._ku3unqa1:hover .linkText{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _25 = "._apju8stv:hover .linkText{-webkit-text-decoration-line:underline;text-decoration-line:underline}";
const _24 = "._1jmq18uv:hover .linkText{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _23 = "._4cvr1h6o{align-items:center}";
const _22 = "._1e0c1txw{display:flex}";
const _21 = "._syaz1qtk{color:var(--ds-link)}";
import React from 'react';
import { charlieTextFontFamily } from '../FontFamily';
import { DiagonalUpwardArrowIcon } from '../Icons/DiagonalUpwardArrowIcon';
import { RightArrowIcon } from '../Icons/RightArrowIcon';
import { TEST_IDS } from '../TestIds';
const _20 = "._k48pni7l{font-weight:600}";
const _19 = "._k48p1nn1{font-weight:400}";
const _18 = "._1wyb1j6v{font-size:1rem}";
const _17 = "._1wyboxwj{font-size:.875rem}";
const _16 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _15 = "._c2waglyw:active{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _14 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _13 = "._9h8h1vef:active{color:var(--ds-link-pressed)}";
const _12 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _11 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _10 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _9 = "._30l31qtk:hover{color:var(--ds-link)}";
const _8 = "._1ygb4suz:focus-visible{outline:2px solid var(--ds-border-focused)}";
const _7 = "._1bas14y2:focus-visible{border-radius:5px}";
const _6 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _5 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _4 = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _3 = "._vwz4gktf{line-height:20px}";
const _2 = "._syaz1blv{color:var(--ds-text)}";
const _ = "._ect41sdi{font-family:Charlie Text,-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const getExternalLinkAttributes = text => {
  const linkText = typeof text === 'string' ? "".concat(text, " ") : '';
  return {
    target: '_blank',
    rel: 'external noopener noreferrer',
    'aria-label': "".concat(linkText, "open in new window")
  };
};
export const SubtleLink = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "a",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_ect41sdi _syaz1blv _vwz4gktf _4bfu18uv _1hmsglyw _ajmmnqa1 _1bas14y2 _1ygb4suz _30l31qtk _9oik18uv _1bnxglyw _jf4cnqa1 _9h8h1vef _1nrm18uv _c2waglyw _1iohnqa1", __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v", __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SubtleLink.displayName = 'SubtleLink';
}
export const Link = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "a",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _21, _3, _7, _8, _13, _17, _18, _19, _20]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_ect41sdi _syaz1qtk _vwz4gktf _1bas14y2 _1ygb4suz _9h8h1vef", __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v", __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Link.displayName = 'Link';
}
const LinkWithIconStyles = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_22, _23, _24, _25, _26, _10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _4cvr1h6o _1jmq18uv _apju8stv _ku3unqa1 _9oik18uv _1bnxglyw _jf4cnqa1", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LinkWithIconStyles.displayName = 'LinkWithIconStyles';
}
export const ExternalLink = props => {
  const externalAttributes = getExternalLinkAttributes(props['aria-label'] || props.children);
  const linkProps = _objectSpread(_objectSpread(_objectSpread({}, props), externalAttributes), {}, {
    size: props.size || 'medium'
  });
  return linkProps.type === 'subtle' ? /*#__PURE__*/React.createElement(SubtleLink, linkProps, props.children) : /*#__PURE__*/React.createElement(Link, linkProps, props.children);
};
const LinkWithIconWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_27, _28, _29]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1o8l _y3gn1e5h _t4pt1hna", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LinkWithIconWrapper.displayName = 'LinkWithIconWrapper';
}
const LastWordWithIcon = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_30, _31, _23]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_o5721q9c _1e0c116y _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LastWordWithIcon.displayName = 'LastWordWithIcon';
}
export const ExternalSubtleLink = props => {
  const externalAttributes = getExternalLinkAttributes(props['aria-label'] || props.children);
  const linkProps = _objectSpread(_objectSpread({}, props), externalAttributes);
  return /*#__PURE__*/React.createElement(SubtleLink, linkProps, props.children);
};
export const LinkWithIcon = _ref6 => {
  let {
      size,
      type = 'internal',
      children,
      href,
      onClick,
      dataTestId
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded6);
  let linkProps = _objectSpread({
    href,
    onClick
  }, props);
  let icon;
  if (type === 'external') {
    icon = /*#__PURE__*/React.createElement(DiagonalUpwardArrowIcon, null);
    const externalAttributes = getExternalLinkAttributes(children);
    linkProps = _objectSpread(_objectSpread({}, externalAttributes), linkProps);
  } else if (type === 'internal') {
    icon = /*#__PURE__*/React.createElement(RightArrowIcon, null);
  }
  if (typeof children === 'string') {
    const words = children.split(' ');
    const lastWord = words.pop();
    return /*#__PURE__*/React.createElement(LinkWithIconStyles, _extends({
      size: size
    }, linkProps, {
      "data-testid": dataTestId || TEST_IDS.APP_LINK_WITH_ICON
    }), /*#__PURE__*/React.createElement(LinkWithIconWrapper, null, /*#__PURE__*/React.createElement("span", {
      className: "linkText"
    }, words.join(' ')), ' ', /*#__PURE__*/React.createElement(LastWordWithIcon, null, /*#__PURE__*/React.createElement("span", {
      className: "linkText"
    }, lastWord), icon)));
  }
  return /*#__PURE__*/React.createElement(LinkWithIconStyles, _extends({
    size: size
  }, linkProps, {
    "data-testid": TEST_IDS.APP_LINK_WITH_ICON
  }), /*#__PURE__*/React.createElement("span", {
    className: "linkText"
  }, children), icon);
};